import { SetupAssistantForm } from '@pages/project/activities/setupAssistant/setupAssistant.types';
import { useEffect, useState } from 'react';
import { useAppSelector } from '@app/hooks';
import { useHandleActivityState } from '@pages/activityBuilder/hooks/useHandleActivityState';
import { selectCurrentProject } from '@features/project/projectSlice';
import { useModulesInput } from '@pages/project/activities/setupAssistant/hooks/useModulesInput';
import { useSetupAssistantFinish } from '@pages/project/activities/setupAssistant/hooks/useSetupAssistantFinish';
import { createActivityInitialValues } from '@pages/activity/activityForm';
import { FinalForm } from '@pages/project/activities/setupAssistant/SetupAssistantFinish';

const initValues: FinalForm = {
  modulesList: [],
  area: undefined,
  landUse_start: undefined,
  landUse_w: undefined,
  landUse_wo: undefined,
};


export const useEditModules = ({ setIsSuccessModalOpen }: { setIsSuccessModalOpen: (isOpen: boolean) => void }) => {
  const [values, setValues] = useState<SetupAssistantForm>({})
  const { activity } = useHandleActivityState();
  const { project } = useAppSelector(selectCurrentProject)

  const editModulesProps = useSetupAssistantFinish([], values, () => {
    setIsSuccessModalOpen(true);
  });

  const modulesInput = useModulesInput();
  const initialValues: FinalForm = {
    ...initValues,
    modulesList: [...editModulesProps.preSelected],
    area: editModulesProps.area,
    ...editModulesProps.lucs
  };

  useEffect(() => {
    if (activity && project)
      setValues({ activity: createActivityInitialValues(project, { activity }).activity })
  }, [activity, project])

  return {
    editModulesProps,
    modulesInput,
    initialValues,
    values
  }
}